import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/StatusBadge";
import { UserCog } from "lucide-react";
import { toast } from "sonner";

export default function Instructors() {
  const navigate = useNavigate();
  const [instructors, setInstructors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/instructors")
      .then((res) => setInstructors(res.data))
      .catch(() => toast.error("Could not load instructors"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-5" data-testid="instructors-page">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">Manage instructor profiles, availability, and vehicle assignments.</p>
        <Button variant="outline" onClick={() => navigate("/staff")} data-testid="instructors-add-button">
          Add Instructor
        </Button>
      </div>
      {loading ? (
        <Skeleton className="h-64 rounded-[var(--radius)]" />
      ) : instructors.length === 0 ? (
        <div className="rounded-[var(--radius)] border bg-card p-12 text-center space-y-2" data-testid="instructors-empty-state">
          <UserCog className="h-8 w-8 mx-auto text-muted-foreground" />
          <p className="text-sm text-muted-foreground">No instructors yet. Add one from Staff & Instructors.</p>
        </div>
      ) : (
        <div className="rounded-[var(--radius)] border bg-card overflow-hidden overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead className="hidden sm:table-cell">Phone</TableHead>
                <TableHead className="hidden md:table-cell">Hourly Rate</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {instructors.map((i) => (
                <TableRow key={i.id} className="cursor-pointer" onClick={() => navigate(`/instructors/${i.id}`)} data-testid="instructor-row">
                  <TableCell className="font-medium">{i.full_name}</TableCell>
                  <TableCell className="hidden sm:table-cell text-muted-foreground">{i.phone || "-"}</TableCell>
                  <TableCell className="hidden md:table-cell text-muted-foreground">{i.hourly_rate ? `$${i.hourly_rate}/hr` : "-"}</TableCell>
                  <TableCell><StatusBadge status={i.status} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
